// @flow

import { graphql } from 'react-relay';
import { ConnectionHandler } from 'relay-runtime';
import createRelayMutation from 'shared/gql/createRelayMutation';

const mutation = graphql`
  mutation AddShipmentItemMutation($input: AddShipmentItemInput!) {
    addShipmentItem(input: $input) {
      shipmentItemEdge {
        node {
          id
          quantity
          description
          pickedQuantity
          fullyPicked
          item {
            id
            name
            itemNumber
            lotTracking
            quantityUOM {
              id
              symbol
            }
          }
          serials {
            id
            serialNumber
          }
          picks {
            id
            quantity
            pickedAt
            lot {
              id
              lotNumber
            }
          }
          createdAt
        }
      }
    }
  }
`;

export default {
  commit: (options: Object) => {
    const shipmentId = options.variables?.input?.shipmentId;
    return createRelayMutation(mutation, {
      ...options,
      updater: store => {
        const payload = store.getRootField('addShipmentItem');
        if (!payload) return;
        const newEdge = payload.getLinkedRecord('shipmentItemEdge');
        if (!newEdge) return;
        const shipmentProxy = store.get(shipmentId);
        if (!shipmentProxy) return;
        const conn = ConnectionHandler.getConnection(shipmentProxy, 'Shipment_items');
        if (conn) {
          ConnectionHandler.insertEdgeBefore(conn, newEdge);
        }
      },
    });
  },
};
